/* unplugin-vue-components disabled */import __unplugin_components_0 from '/workspace/src/components/Spinner.vue';
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PageSection"},[(_vm.loading)?_c('div',{staticClass:"Loading"},[_c(__unplugin_components_0,{attrs:{"theme":"dark"}})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }